import { action, payload } from 'ts-action'
import { IError } from 'models/Global'
import { IAuthPayload, IAuthData } from 'models/Auth'

export const Login = action('Login', payload<IAuthPayload>())
export const SetIsAuthUser = action('SetIsAuthUser')
export const SetUserData = action('SetUserData', payload<IAuthData>())
export const ClearAuthMeta = action('ClearAuthMeta')
export const ClearMeta = action('ClearMeta')
export const LoginErrors = action('LoginErrors', payload<IError>())
export const LoginFetching = action('LoginFetching', payload<boolean>())
export const TwoFactorVerifying = action('TwoFactorVerifying', payload<boolean>())
export const ResendingTwoFactorCode = action('ResendingTwoFactorCode', payload<boolean>())
export const ClearLoginErrors = action('ClearLoginErrors')
export const ClearAuthReducer = action('ClearAuthReducer')
